import React from 'react';
import styled from 'styled-components';
import { RectShape } from 'react-placeholder/lib/placeholders';
import "react-placeholder/lib/reactPlaceholder.css";
import { device, numberToCurrency } from 'vqp-common';

import { fetchPostSaleInfo } from '../../redux/actions/dashboard'
import useFetch from '../../utils/useFetch';
import formatSecondsToReadableTime from '../../utils/formatSecondsToReadableTime'

import { BigInfoCard } from './'

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 15px;
    margin: 15px;

    @media ${device.desktop} {
        grid-template-columns: 1fr 1fr 1fr;
    }
`

const TAGS = {
    COUNTER: 'TempoBalcao',
    DELIVERY: 'TempoDelivery',
    COUPON: 'CuponsUtilizados'
}

export const PostSaleInfoPanel = ({filterDates}) => {

    const postSaleInfo = useFetch(fetchPostSaleInfo, filterDates)

    const drawCard = (title, icon, color, data, {formatTop, formatBottom} = {}) => {
        const dataTop = data[0]
        const dataBottom = data.length > 1 && data[1]
        if (formatTop) {
            dataTop.data = formatTop(dataTop.data)
        }
        if (formatBottom && dataBottom) {
            dataBottom.data = formatBottom(dataBottom.data)
        }
        return (
            <BigInfoCard 
                title={title} 
                icon={icon}
                color={color} 
                valueTop={dataTop && dataTop.data} 
                descTop={dataTop && dataTop.label}
                valueBottom={dataBottom && dataBottom.data}
                descBottom={dataBottom && dataBottom.label}
            />
        )
    }

    if (postSaleInfo.loading) {
        return (
            <Grid>
                <RectShape color='#E0E0E0' showLoadingAnimation={true} style={{ width: '100%', height: 300 }} />
                <RectShape color='#E0E0E0' showLoadingAnimation={true} style={{ width: '100%', height: 300 }} />
                <RectShape color='#E0E0E0' showLoadingAnimation={true} style={{ width: '100%', height: 300 }} />
            </Grid>
        )
    } else if (postSaleInfo.response) {
        const counterCard = postSaleInfo.response.filter(data => data.tag === TAGS.COUNTER)
        const deliveryCard = postSaleInfo.response.filter(data => data.tag === TAGS.DELIVERY)
        const couponCard = postSaleInfo.response.filter(data => data.tag === TAGS.COUPON)
        return (
            <Grid>
                {drawCard("Tempo Atendimento Balcão (média)", "bagBig", "primary", counterCard, {formatTop: formatSecondsToReadableTime})}
                {drawCard("Tempo de Delivery (média)", "bikeBig", "secondary", deliveryCard, {formatTop: formatSecondsToReadableTime, formatBottom: formatSecondsToReadableTime})}
                {drawCard("Cupons utilizados", "couponsBig" , "primary", couponCard, {formatTop: numberToCurrency})}
            </Grid>
        )
    }
    
    return null
}